
























  import Debug from 'debug'
  import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
  import { resolve } from '@/app/container';
  import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
  import {
    SectionInteractionEvent,
    SectionInteractedEventName
  } from '@/app/statistics/events/section-interaction-events';
  import { CLICK_IMAGE_TYPE } from '@/app/statistics/handlers/click-image-items-completion-handler';
  import * as Api from "@/app/interaction/api";
  import { ClickImageState, ClickImageItem, ClickImageContent } from "./click-image-interfaces";
  import { TranslateResult } from 'vue-i18n';
  import i18n from '@/plugins/i18n';

  const debug = Debug('click-image-component')

  interface CardItem {
    content: string;
    imageUri: string;
    title: string | null;
    selected: boolean;
    touched: boolean;
  }


  @Component({
    components: {}
  })
export default class ClickimageComponent extends Vue implements Api.InteractiveComponent<ClickImageState, ClickImageContent> {

    @Prop({
      required: true
    })
    public meta: Api.InteractionComponentMeta;

    @Prop({
      required: true
    })
    public content: ClickImageContent;

    @Prop({
      required: true
    })
    public state: ClickImageState | null;

    private largeCards: boolean = true; // TODO: how to get it?

    private cardItems: CardItem[] = this.initialCardItems;

    private get initialCardItems(): CardItem[] {
      let items: CardItem[] = [];
      this.content.items.forEach((item: ClickImageItem, index: number) => {
        items.push({
          ...item,
          selected: this.state?.states[index] || false,
          touched: this.state?.touched[index] || false,
        });
      });

      return items;
    }

    private showCard(item: CardItem, index: number): void {

      debug('showCard', item, index);

      item.selected = !item.selected;

      const progressChanged = !item.touched;
      item.touched = true;

      this.emitInteractionStateChanged();
      if (progressChanged) {
        this.emitInteractionResultChanged();
      }
    }

    @Emit('interaction-result-changed')
    public emitInteractionResultChanged() {
      const progress = this.cardItems.filter(item => item.touched).length / this.cardItems.length;

      const result: Api.Result = {
        progress,
        status: progress < 1 ? 'incomplete' : 'completed'
      }

      debug('emitInteractionResultChanged', result);

      return result
    }

    @Emit('interaction-state-changed')
    public emitInteractionStateChanged() {

      const state = {
        states: this.cardItems.map((item: CardItem) => item.selected),
        touched: this.cardItems.map(item => item.touched || false)
      };

      debug('emitInteractionStateChanged', state);

      return state
    }

    private t(key: string, params: any = {}): TranslateResult {
      return i18n.t(key, params);
    }
  }
